// shelter.js
import { defineStore } from 'pinia'
import axios from 'axios'

export const useShelterStore = defineStore('shelter', {
    state: () => ({
        AllShelter: [],
        AllShelterTransfer: [],
        shelterList: [],
        AllUtility: [],
        AllShelterStaff: [],
        AllShelterPosition: [],
        medicalTeamScheduleDailyList: [],
        medicalTeamScheduleMonthList1: [],
        medicalTeamScheduleMonthList2: [],

        AllShelterType: [],
    }),
    actions: {
        async getAllShelter(filter) {
            const body = {
                ...filter,
                status: 1
            }
            try {
                const response = await axios.get('/shelter', { params: body })
                if (response.status === 200) {
                    this.AllShelter = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getAllShelterTransfer(filter) {
            const body = {
                ...filter,
                max_capacity: false,
                status: 1
            }
            try {
                const response = await axios.get('/shelter', { params: body })
                if (response.status === 200) {
                    this.AllShelterTransfer = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getAllShelterForStaff(filter) {
            const body = {
                ...filter,
            }
            try {
                const response = await axios.get('/shelter', { params: body })
                if (response.status === 200) {
                    this.AllShelter = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getShelter(filter) {
            try {
                const response = await axios.get('/shelter', { params: filter })
                if (response.status === 200) {
                    this.shelterList = response.data.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getShelterById(id) {
            try {
                const response = await axios.get(`/shelter/${id}`,)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getUtility(filter) {
            try {
                const response = await axios.get('/shelter-utility', { params: filter })
                if (response.status === 200) {
                    this.AllUtility = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async createShelter(body) {
            try {
                const response = await axios.post('/shelter', body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async updateShelter(id, body) {
            try {
                const response = await axios.post(`/shelter/${id}`, body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        // staff
        async getAllShelterStaff(filter) {
            try {
                const response = await axios.get('/staff', { params: filter })
                if (response.status === 200) {
                    if (filter.paginate) {
                        this.AllShelterStaff = response.data.data.data
                    } else {
                        // console.log('response', response);
                    }
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getAllShelterStaffByShelterPositionId(filter) {
            try {
                const response = await axios.get('/staff', { params: filter })
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async addStaffToShelter(body) {
            try {
                const response = await axios.post('/staff', body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async staffJoinShelter(body) {
            try {
                const response = await axios.post('/staff/join', body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async transferStaff(id, body) {
            try {
                const response = await axios.post(`/staff/transfer/${id}`, body)
                if (response.status === 200) {
                    // console.log('response:', response)
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async exitStaff(id, body) {
            try {
                const response = await axios.post(`/staff/exit/${id}`, body)
                if (response.status === 200) {
                    // console.log('response:', response)
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async exitAllStaff(body) {
            try {
                const response = await axios.post(`/staff/exit-all`, body)
                if (response.status === 200) {
                    // console.log('response:', response)
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async assignPositionToStaff(id, body) {
            try {
                const response = await axios.post(`/staff/assign/${id}`, body)
                if (response.status === 200) {
                    // console.log('response:', response)
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        // position
        async getAllShelterPosition(filter) {
            try {
                const response = await axios.get('/shelter-position', { params: filter })
                if (response.status === 200) {
                    this.AllShelterPosition = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        // team
        async getMedicalTeamScheduleDailyCurrentlyInShelter(filter) {
            try {
                const response = await axios.get('/appointment-daily', { params: filter })
                if (response.status === 200) {
                    this.medicalTeamScheduleDailyList = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getMedicalTeamScheduleDailyInShelter(filter) {
            try {
                const response = await axios.get('/appointment-daily', { params: filter })
                if (response.status === 200) {
                    // console.log('response:', response)
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getMedicalTeamScheduleMonthInShelter(filter) {
            try {
                const response = await axios.get('/appointment-month', { params: filter })
                if (response.status === 200) {
                    if (filter.type == 1) {
                        this.medicalTeamScheduleMonthList1 = response.data.data.map((data, index) => ({
                            id: ++index,
                            start: data.date,
                            extendedProps: {
                                total_shelter: data.total_shelter || 1,
                                total_team: data.total_team || 0,
                            },
                        }));
                    } else if (filter.type == 2) {
                        this.medicalTeamScheduleMonthList2 = response.data.data.data
                    }
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },


        async getShelterPoint(filter) {
            try {
                const response = await axios.get('/shelter-point', { params: filter, noLoader: true })
                if (response.status === 200) {
                    //
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getShelterTypes(filter) {
            try {
                const response = await axios.get('/shelter-types', { params: filter, noLoader: true })
                if (response.status === 200) {
                    console.log('responseasd',response);
                    
                    this.AllShelterType = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async autoCompleteAddress(filter) {
            try {
                const response = await axios.get('/address', { params: filter, noLoader: true })
                if (response.status === 200) {
                    //
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
    }
})
